module.exports = __webpack_public_path__ + "static/media/icon-menu-list-active.be56e963.svg";